module.exports = __webpack_public_path__ + "img/turks-and-caicos.4993f68e.png";